import { useEffect, useState, useCallback } from 'react';

const DELAY_TIME = 1750;
const MAX_LOADING_TIME = 10000;

interface UseCheckFaceTecSDKReturn {
  isSDKReady: boolean;
  isLoading: boolean;
  hasError: boolean;
}

export const useCheckFaceTecSDK = (): UseCheckFaceTecSDKReturn => {
  const [isSDKReady, setIsSDKReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const checkSDKAvailability = useCallback(() => {
    return typeof window !== 'undefined' && 'FaceTecSDK' in window;
  }, []);

  const setupSDK = useCallback(() => {
    if (checkSDKAvailability()) {
      setTimeout(() => {
        setIsSDKReady(true);
        setIsLoading(false);
      }, DELAY_TIME);
      return true;
    }
    return false;
  }, [checkSDKAvailability]);

  useEffect(() => {
    if (setupSDK()) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (setupSDK()) {
        observer.disconnect();
      }
    });

    observer.observe(document, {
      childList: true,
      subtree: true,
    });

    const errorTimeout = setTimeout(() => {
      setIsLoading(false);
      setHasError(true);
    }, MAX_LOADING_TIME);

    return () => {
      observer.disconnect();
      clearTimeout(errorTimeout);
    };
  }, [setupSDK]);

  return { isSDKReady, isLoading, hasError };
};
